import Cookies from 'js-cookie'

import { ensureFloat, ensureString } from '@/mixins/useEnsure'
import BrowserService from '@/services/browserService'
import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import { useAppStore } from '@/stores/AppStore'

export default (order) => {
  const lcKey = 'mpo'
  const { isFavorite } = useAppStore()
  const purchasedOrdersData = localStorage.getItem(lcKey)
  const purchasedOrders = purchasedOrdersData === null ? [] : JSON.parse(localStorage.getItem(lcKey))

  // MPO is mixit purchase order, we send GTM purchase event only if MPO is null
  if (!purchasedOrders.includes(order.uuid) && order.mpo === null) {
    // Adds order uuid to the list of purchased orders.
    purchasedOrders.push(order.uuid)
    // Saves purchased orders to localStorage.
    localStorage.setItem(lcKey, JSON.stringify(purchasedOrders))
    // Updates the order status in the backend which prevents sending the GTM event multiple times.
    ApiServiceV1.put(`orders/${order.hash}/update-status`)

    const productList = order.products.map((p) => {
      let category
      switch (p.kind) {
        case 'transport': {
          category = 'Doprava'
          break
        }
        case 'payment': {
          category = 'Platba'
          break
        }
        default: {
          category = undefined
        }
      }
      return {
        id: ensureString(p.productId),
        name: p.name,
        favorite: isFavorite(p.id),
        categories:
          category ||
          p.categories.map((c) => {
            return c.title
          }),
        labels: p.properties.map((pro) => {
          return pro.name
        }),
        availability: 'stock',
        price: ensureFloat(p.price),
        discount: p.discount,
        quantity: p.quantity,
      }
    })

    const mixList = order.mixes.map((m) => {
      const categories = []
      categories.push('Mixy', m.localizedKind)
      return {
        id: ensureString(m.mixId),
        name: m.name,
        favorite: false,
        categories,
        labels: [],
        availability: 'stock',
        price: ensureFloat(m.price),
        discount: m.discount,
        quantity: m.quantity,
      }
    })

    const items = [...productList, ...mixList]

    const payload = ({
      event: 'purchase',
      platform: BrowserService.platform(),
      ecommerce: {
        id: order.variableSymbol,
        value: order.gaTransactionTotal,
        payment: order.totalPrice,
        tax: order.gaTransactionVat,
        shipping: order.selectedTransport.priceWithoutVat,
        currency: order.currencyCode,
        products: items,
        user: {
          email: order.customerEmail,
          phone: order.customerPhone,
        },
        cjevent: Cookies.get('cjevent'),
      },
      _clear: true,
    })
    window.dataLayer?.push(payload)

    // Sets last order hash
    localStorage.setItem('mlo', JSON.stringify({ hash: order.hash, time: Date.now() }))
  }
}
